/*
Sohel 11/01/2023 5314488544 new MUI table Implemented table data
uday 3-11-23 5314488544 fixed eligibility ui changes
sohel 11/04/2023 5314488544 fixed extra space issue
*/

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  link: {
    // Changed field list code column font color (2700799562)
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
  detailsCard: {
    padding: '15px !important',
    display: 'flex',
    flexDirection: 'column',
  },
  mainHeading: {
    fontWeight: 'bold !important',
    fontSize: '1rem',
    fontFamily: 'articulat-cf, sans-serif !important',
    marginBottom: '20px',
    width: '50%',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    color: '#707070',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
  pronoSection: {
    borderBottom: '1px solid #0000004f',
    margin: '10px 5px 15px',
  },
}));
const EligibiltyMedicareUI = ({ stateMedicaidResponse }) => {
  const classes1 = useStyles();

  return (
    <>
      {stateMedicaidResponse?.medicareCoverageInfo && (
        <>
          <div className={classes1.pronoSection}>
            <h6 className={classes1.mainHeading}>Coverage Info : </h6>
            <div className="row mb-2">
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Eligibility Code :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo.eligibilityCode}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Validation Response :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo?.validationResponse
                      ? stateMedicaidResponse?.medicareCoverageInfo?.validationResponse
                      : ''}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Member ID :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo?.memberId}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Coverage Description :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo?.coverageDescription}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Managed Care Program :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo?.managedCareProgram}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  MCO Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicareCoverageInfo?.mcoName}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}

      {stateMedicaidResponse?.primaryCoverage && (
        <>
          <div className={classes1.pronoSection}>
            <h6 className={classes1.mainHeading}>Coverage 1 :</h6>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Coverage Description :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.coverageDescription}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Payer Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.primaryPayerName}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Policy Number :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.primaryPolicyNumber}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Group Number :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.groupNumber}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Member First Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.memberFirstName}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Member Last Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.primaryCoverage?.memberLastName}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}
      {stateMedicaidResponse?.secondaryCoverage && (
        <>
          <div className={classes1.pronoSection}>
            <h6 className={classes1.mainHeading}>Coverage 2 :</h6>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Payer Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.secondaryCoverage?.secondaryPayerName}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Member ID :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.secondaryCoverage?.secondaryMemberId}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}
      {stateMedicaidResponse?.tertiaryCoverage && (
        <>
          <div className={classes1.pronoSection}>
            <h6 className={classes1.mainHeading}>Coverage 3 :</h6>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Payer Name :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.tertiaryCoverage?.tertiaryPayerName}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Member ID :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.tertiaryCoverage?.tertiaryMemberId}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}
      {stateMedicaidResponse?.medicare && (
        <>
          <div>
            <h6 className={classes1.mainHeading}>Medicare :</h6>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Medicare Part A :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicare?.medicarePartA}
                  </span>
                </Typography>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                <Typography className={classes1.heading}>
                  Medicare Part B :
                  <span className="processor-label">
                    &nbsp;
                    {stateMedicaidResponse?.medicare?.medicarePartB}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EligibiltyMedicareUI;
